import { lazy } from 'react'

export const ResourceList = lazy(() => import('./resource/ResourceList'));
export const ResourceDetails = lazy(() => import('./resource/ResourceDetails'));
export const BookingList = lazy(() => import('./booking/BookingList'));
export const AdminAmenities = lazy(() => import('./admin_amenities/AdminAmenities'));